import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ReadyToShareGrid = ({ items, onCopy, onDownload }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="px-4 py-3 md:px-6 md:py-4 border-b border-border">
        <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">Ready to Share</h2>
        <p className="text-xs md:text-sm text-muted-foreground mt-1 font-caption">Curated content for immediate use</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 p-4 md:p-6">
        {items?.map((item) => (
          <div
            key={item?.id}
            className="bg-background border border-border rounded-lg overflow-hidden hover:shadow-md transition-all duration-250"
          >
            <div className="relative aspect-square overflow-hidden bg-muted">
              <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover"
              />
              <div className="absolute top-2 right-2 bg-white rounded-full px-3 py-1.5 shadow-md flex items-center gap-1.5">
                <span className="text-xs font-medium uppercase text-gray-700">{item?.contentType}</span>
              </div>
            </div>

            <div className="p-3 md:p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground mb-2 line-clamp-2">
                {item?.title}
              </h3>
              <p className="text-xs md:text-sm text-muted-foreground mb-3 line-clamp-2">
                {item?.description}
              </p>

              <div className="flex items-center gap-2 mb-3">
                <Icon name="Calendar" size={14} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground font-caption">{item?.date}</span>
              </div>

              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onCopy(item?.caption)}
                  iconName="Copy"
                  fullWidth
                >
                  Copy
                </Button>
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => onDownload(item?.image, item?.title)}
                  iconName="Download"
                  fullWidth
                >
                  Download
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReadyToShareGrid;